import { useState, useCallback } from 'react'

export interface UseAddMemberModalProps {
  onSuccess?: () => void
}

export function useAddMemberModal({ onSuccess }: UseAddMemberModalProps = {}) {
  const [isOpen, setIsOpen] = useState(false)

  const openModal = useCallback(() => {
    setIsOpen(true)
  }, [])

  const closeModal = useCallback(() => {
    setIsOpen(false)
  }, [])

  return {
    isOpen,
    openModal,
    closeModal,
    onSuccess
  }
}
